/**
 * Returns the correct form of a word based on the provided value, in Polish language.
 *
 * @param {Array}  
 * @param {number} 
 * @returns {string} 
 * @example
 *
 * // Returns 'opinii'
 * getPolishPlurals(['opinia', 'opinie', 'opinii'], 5);
 *
 * // Returns 'opinia'
 * const votesLabel = getPolishPlurals.bind(null, 'opinia', 'opinie', 'opinii');
 * console.log(votesLabel(1));
 */

export const getPolishPlurals = ([singular, pluralNominativ, pluralGenitive], value) => {
  const absValue = Math.abs(value);
  if (absValue === 1) {
    return singular;
  }
  const lastDigit = absValue % 10;
  const lastTwoDigits = absValue % 100;
  if (lastDigit >= 2 && lastDigit <= 4 && (lastTwoDigits < 10 || lastTwoDigits >= 20)) {
    return pluralNominativ;
  }
  return pluralGenitive;
};

/**
 * Returns the correct form of a word based on the provided value, in English language.
 *
 * @param {Array}  
 * @param {number}  
 * @returns {string} 
 *
 * @example
 *
 * // Returns 'votes'
 * getEnglishPlurals(['vote', 'votes'], 5);
 *
 * // Returns 'vote'
 * const voteLabel = getEnglishPlurals.bind(null, 'vote', 'votes');
 * console.log(voteLabel(1));
 */

export const getEnglishPlurals = ([singular, plural], value) => {
  const absValue = Math.abs(value);
  if (absValue === 1) {
    return singular;
  }
  return plural;
};